export default __webpack_public_path__ + "static/bsfi-gift-box-206acb20a6d5cc40c333271cf7854c18.gif";